//@flow
import moment from 'moment';
import WavePlayerComment from '../video/lib/WavePlayerComment';

const debug = require('../debug/debug')('wc:util:VideoUtil');

/**
 * Format with frame rate in it.
 */
export const TIME_WITH_FRAME_FORMAT: string = 'hh:mm:ss:ff';
/**
 * For for hour minute second and millisecond
 */
export const HH_MM_SS_SSS: string = 'hh:mm:ss.SSS';

export const playbackRateOptions = [
  { value: 0.25, label: 'Speed 0.25x' },
  { value: 0.5, label: 'Speed 0.5x' },
  { value: 1, label: 'Speed 1x' },
  { value: 1.25, label: 'Speed 1.25x' },
  { value: 1.5, label: 'Speed 1.5x' },
  { value: 2, label: 'Speed 2x' },
  { value: 4, label: 'Speed 4x' },
  { value: 8, label: 'Speed 8x' }
];

export function toMSS(millis: number) {
  const m1 = moment.duration(millis);
  const minutes = Math.floor(m1.asMinutes());
  const m2 = m1.clone().add(-minutes, 'minutes');
  const seconds = Math.floor(m2.asSeconds());
  return `${wrap(minutes)}:${wrap(seconds)}`;
}

function toSMPTENoFrames(millis: number) {
  const m1 = moment.duration(millis);
  const hours = Math.floor(m1.asHours());
  const m2 = m1.clone().add(-hours, 'hours');
  const minutes = Math.floor(m2.asMinutes());
  const m3 = m2.clone().add(-minutes, 'minutes');
  const seconds = Math.floor(m3.asSeconds());
  const m4 = m3.clone().add(-seconds, 'seconds');
  const milliseconds = Math.round(m4.asMilliseconds());
  return `${wrap(hours)}:${wrap(minutes)}:${wrap(seconds)}.${wrapMillis(milliseconds)}`;
}

export function toSMPTE(millis: number, frameRate: number = 0, format: string = TIME_WITH_FRAME_FORMAT) {
  return convertSecondsToSMPTE((millis + 1) / 1000, frameRate);
  if (frameRate === 0) {
    return toSMPTENoFrames(millis);
  }

  let totalFrame = (millis / 1000) * frameRate;
  //  console.log("Total Frame: ", totalFrame)

  const framesInMiutes = 60 * frameRate;
  const framesInHours = 60 * framesInMiutes;
  const hours = Math.floor(totalFrame / framesInHours);
  totalFrame = totalFrame % framesInHours;
  //console.log(totalFrame, "remainigFrames");
  const minutes = Math.floor(totalFrame / framesInMiutes);
  totalFrame = totalFrame % framesInMiutes;
  //console.log(totalFrame, "remainigFrames");
  const seconds = Math.floor(totalFrame / frameRate);
  totalFrame = Math.round(totalFrame % frameRate);
  //console.log(totalFrame, "remainigFrames");
  //millis = totalFrame*1000
  //onsole.log(millis,"remaining millis");
  //onst leftFrames = Math.round(millis/frameRate);
  //console.log(hours, "hour(s)", minutes, "minute(s)", seconds, "seconds", totalFrame, "frames");
  /* const frameNumber: number = Number(millis / 1000 * frameRate);
  const hour: number = frameRate * 60 * 60,
    minute = frameRate * 60;
  const hours: number = parseInt(frameNumber / hour); //toFixed round off the nmber - Om
  const minutes = Number((frameNumber / minute).toString().split('.')[0]) % 60;
  const seconds = Number((frameNumber / frameRate).toString().split('.')[0]) % 60; */
  let value = format.toLowerCase();
  value = value.replace('ff', wrap(totalFrame) + '');
  value = value.replace('ss', wrap(seconds) + '');
  value = value.replace('mm', wrap(minutes) + '');
  value = value.replace('hh', wrap(hours) + '');
  //const smpte = `${wrap(hours)}:${wrap(minutes)}:${wrap(seconds)}.${wrap(Math.floor(frameNumber % frameRate))}`;
  //return smpte;
  return value;
}

export function smpteToMillis(str: string, frameRate: number = 0): number {
  frameRate = Math.max(frameRate, 1);

  let hours: number = 0;
  let minutes: number = 0;
  let seconds: number = 0;
  let millis: number = 0;
  let frames: number = 0;
  let index: number = 0;

  let dotIndex = -1;
  if ((dotIndex = str.indexOf('.')) != -1) {
    millis = parseFloat(str.substr(dotIndex + 1));
    // console.log('Frames', frames);
    if (dotIndex > 0) {
      str = str.substring(0, dotIndex);
    }
  }

  const splitArray = str.split(':');

  if (splitArray.length == 4) {
    hours = parseFloat(splitArray[0]);
    minutes = parseFloat(splitArray[1]);
    seconds = parseFloat(splitArray[2]);
    frames = parseFloat(splitArray[3]);
  }
  if (splitArray.length == 3) {
    /* hours = parseFloat(splitArray[0]);
    minutes = parseFloat(splitArray[1]);
    seconds = parseFloat(splitArray[2]); */
    minutes = parseFloat(splitArray[0]);
    seconds = parseFloat(splitArray[1]);
    frames = parseFloat(splitArray[2]);
  }

  if (splitArray.length == 2) {
    minutes = parseFloat(splitArray[0]);
    seconds = parseFloat(splitArray[1]);
  }

  if (splitArray.length == 1) {
    seconds = parseFloat(splitArray[0]);
  }

  return (
    hours * 60 * 60 * 1000 +
    minutes * 60 * 1000 +
    seconds * 1000 +
    millis +
    (frames > 0 ? Math.round((frames / frameRate) * 1000) : 0)
  );
}

function wrap(n: number) {
  return n < 10 ? '0' + n : n;
}

function wrapMillis(n) {
  let s = String(n);
  while (s.length < 3) {
    s += '0';
  }
  return s;
}

export function isWaveplayerComment(c: ?any) {
  return (
    c &&
    c._annotation &&
    c._annotation._attachments &&
    c._annotation._attachments.length > 0 &&
    c._annotation._attachments[0]._data &&
    c._annotation._attachments[0]._fileName === WavePlayerComment.FILENAME
  );
}

/**
 * Parses an input string into a number representing the seconds of video playback.
 *
 * Useful to set the `currentTime` property of a media element.
 *
 * Accepted format examples:
 *
 *   00:22:30          absolute time
 *   00:22:30.12       absolute time with frames
 *   00:22:30.12+5     absolute time plus relative change
 *   00:22:30.12+2.05  absolute time plus relative change with frames
 *   00:22:30.12-10:00 absolute time minus relative change
 *   00:22:30.12+5s    absolute time plus relative change shorthand
 *   00:22:30.12+10m   absolute time plus relative change shorthand
 *   00:22:30.12+1h    absolute time plus relative change shorthand
 */
export function parsePlaybackTime(value: string, frameRate: number): ?number {
  let parsedVal = null;

  try {
    const timecodeRegex = /^\d\d?(:\d\d){0,2}(\.\d\d{0,2})?$/;

    const tokens = value.split(/[+-]/);
    if (tokens.length > 2) {
      return null;
    }

    if (tokens.length === 1) {
      if (!timecodeRegex.test(value)) {
        return null;
      }

      // User entered an absolute time. Parse that.
      return smpteToMillis(value, frameRate) / 1000;
    }

    // User may have entered an absolute time with relative change. Check it.
    const shorthandRegex = /^(\d+)([hmsf])$/i;
    const [baseTimeStr, changeStr] = tokens;
    const baseTime = smpteToMillis(baseTimeStr, frameRate) / 1000;
    if (baseTime === null) {
      return null;
    }

    const isPositive = value.indexOf('+') > -1;

    if (shorthandRegex.test(changeStr)) {
      const arr = shorthandRegex.exec(changeStr);
      const changeValue = parseFloat(arr[1]);
      const changeUnit = arr[2].toLowerCase();
      let changeSeconds = 0;
      switch (changeUnit) {
        case 'h':
          changeSeconds = changeValue * 60 * 60;
          break;
        case 'm':
          changeSeconds = changeValue * 60;
          break;
        case 's':
          changeSeconds = changeValue;
          break;
        case 'f':
          changeSeconds = changeValue / frameRate;
      }

      parsedVal = isPositive ? baseTime + changeSeconds : baseTime - changeSeconds;
    } else if (timecodeRegex.test(changeStr)) {
      const changeMillis = smpteToMillis(changeStr, frameRate);
      if (changeMillis === null) {
        return null;
      }

      const changeSeconds = changeMillis / 1000;
      parsedVal = isPositive ? baseTime + changeSeconds : baseTime - changeSeconds;
    }
  } catch (err) {
    debug('[parsePlaybackTime()] error: ', err);
  }

  return parsedVal;
}

export function convertSecondsToSMPTE(time: number | string, framerate: number | string) {
  let dropframes: number = 0;
  time = parseFloat(time) || 0;
  framerate = parseFloat(framerate);

  /* make sure to use "less than" / "greater than" and not "less than or equal to" so that it only checks for decimals and not whole numbers (i.e. 29.97 and not 29 or 30) */

  if (framerate > 29 && framerate < 30) {
    dropframes = 2;
  } else if (framerate > 59 && framerate < 60) {
    dropframes = 4;
  } else {
    dropframes = 0;
  }

  let totalFrames: number = framerate * time;
  let framesLeft: number = framerate * time;
  let roundedFramerate: number = Math.round(framerate);

  if (framerate <= 0 || roundedFramerate <= 0) {
    return formatTime(time, framerate);
  }

  /* figure out the amount of dropframes
     for 29.97 video, it adds 2 frames every minute, except for minutes that are multiples of 10   */

  let totalMinutes: number = Math.floor(totalFrames / (60 * roundedFramerate));
  let totalDropframes: number = dropframes * (totalMinutes - Math.floor(totalMinutes / 10));

  let newDropframes: number = totalDropframes;
  let oldDropframes: number = 0;
  let dropDiff: number = 0;
  let foundAll: boolean = false;

  while (!foundAll) {
    /* $dropDiff = (amount of dropframes in total + newDropframes) - (amount of dropframes in total + oldDropframes); */
    dropDiff =
      dropframes *
        (Math.floor((totalFrames + newDropframes) / (60 * roundedFramerate)) -
          Math.floor(Math.floor((totalFrames + newDropframes) / (60 * roundedFramerate)) / 10)) -
      dropframes *
        (Math.floor((totalFrames + oldDropframes) / (60 * roundedFramerate)) -
          Math.floor(Math.floor((totalFrames + oldDropframes) / (60 * roundedFramerate)) / 10));

    if (dropDiff > 0) {
      oldDropframes = newDropframes;
      newDropframes += dropDiff;
    } else {
      foundAll = true;
    }
  }

  totalDropframes = newDropframes;

  totalFrames += totalDropframes;
  framesLeft += totalDropframes;

  /* After 18 hours, therer are only 2 bonus drop frames added (drop frames created by adding the other drop frames). So let's just not track them. Leave the next row commented out for now
     var bonusDropframes = dropframes * ((totalDropframes / roundedFramerate / 60) - floor((totalDropframes / roundedFramerate / 60) / 10));    */

  let hours = Math.floor(totalFrames / (60 * 60 * roundedFramerate));
  framesLeft -= hours * (60 * 60 * roundedFramerate);

  let minutes = Math.floor(framesLeft / (60 * roundedFramerate));
  framesLeft -= minutes * (60 * roundedFramerate);

  let seconds = Math.floor(framesLeft / roundedFramerate);
  framesLeft -= seconds * roundedFramerate;

  let frames = Math.floor(framesLeft);

  let sep = ':';
  if (dropframes > 0) {
    sep = ';';
  }

  let hourstext = String(hours) + sep;
  let minutestext = String(minutes) + sep;
  let secondstext = String(seconds) + sep;
  let framestext = String(frames);

  if (hours < 10) {
    hourstext = '0' + hourstext;
  }
  if (hours == 0) {
    hourstext = '';
  }
  if (minutes < 10) {
    minutestext = '0' + minutestext;
  }
  if (seconds < 10) {
    secondstext = '0' + secondstext;
  }
  if (frames < 10) {
    framestext = '0' + framestext;
  }

  return hourstext + minutestext + secondstext + framestext;
}

function formatTime(time: number | string, framerate: number | string) {
  time = parseFloat(time);
  framerate = parseFloat(framerate) || 0;

  let hours = Math.floor(time / 3600);
  let mins = Math.floor((time / 60) % 60);
  let secs = time % 60;
  let frames = secs - Math.floor(secs);
  secs = Math.floor(secs);
  let frames_separator = '.';
  let frames_text;
  if (framerate > 0 && typeof framerate !== 'undefined') {
    frames = Math.floor(frames * framerate);
    frames_separator = ':';
    frames_text = frames < 10 ? '0' + frames : frames;
  } else {
    frames = frames.toFixed(3);
    frames_text = String(frames).substr(2);
  }

  let minutes = mins < 10 ? '0' + mins : mins;
  let seconds = secs < 10 ? '0' + secs : secs;

  return hours + ':' + minutes + ':' + seconds + frames_separator + frames_text;
}

export function isCompareViewMode() {
  const compareElement = document.getElementsByName('CompareRevisions');
  if (compareElement.length) return true;
  else return false;
}
